// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import decode from "ent/decode";
import type {
  ContentServiceStoryHeadlines,
  DaperStoryHeadlines,
} from "@foundation/intercom-client";

export const getHeadlineMarkup = ({
  headlines,
}: {
  headlines: DaperStoryHeadlines | ContentServiceStoryHeadlines;
}) => {
  const { markup, web } = headlines;

  if (markup?.web) return markup.web;

  return web;
};

export const getHeadline = ({
  headlines,
}: {
  headlines: DaperStoryHeadlines | ContentServiceStoryHeadlines;
}) => {
  const html = getHeadlineMarkup({ headlines });

  return decode(html.replace(/<[^>]*>?/g, ""));
};
